import React from "react";
import { withStyles } from "material-ui/styles";
import PropTypes from "prop-types";
import List, { ListSubheader } from "material-ui/List";
import UserListItemContainer from "./UserListItemContainer";

import { grey } from "material-ui/colors";

const styles = {
  grow: {
    flex: "1 1 auto"
  },
  badge: {
    margin: "10px 16px 0"
  },
  avatar: {
    margin: 10,
    width: 40,
    height: 40
  },
  subheader: {
    backgroundColor: grey[100],
    margin: 0
  },
  list: {
    margin: 0
  }
};

const UserListSection = props => {
  const { classes, header, users } = props;

  const renderUsers = () =>
    users.map((user, i) => <UserListItemContainer key={i} user={user} />);

  if (users.length === 0) return null;

  return (
    <List
      className={classes.list}
      subheader={
        <ListSubheader className={classes.subheader}>{header}</ListSubheader>
      }
    >
      {renderUsers()}
    </List>
  );
};

UserListSection.propTypes = {
  header: PropTypes.string.isRequired,
  users: PropTypes.array.isRequired
};
export default withStyles(styles, { name: "UserListSection" })(UserListSection);



// WEBPACK FOOTER //
// ./src/UserListSection.js